/**
 * Cursor Trails — custom cursor trail effects
 *
 * Declares one web-accessible-resource entry matched to every http(s) origin with no
 * `use_dynamic_url`, exposing `images/*.*` — which, because WAR wildcards span path
 * separators, covers everything under `images/`, including the `images/icons/` subtree.
 * Each asset resolves at a fixed URL from any page.
 *
 * The `images/icons/128.png` icon is the primary signal, loaded through `probeImage`
 * with no CORS grant, corroborated by another icon and the vendor-named `close-btn.svg`.
 * All fire only when installed.
 *
 * Manifest verified against version 4.5.1.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ilngnjopnchkedjkdjlalnlbfpkhmbie';

export const cursorTrails: ExtensionDefinition = {
  id: ID,
  name: 'Cursor Trails - Custom Cursor Trails',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 70_000,
  notes:
    'One static WAR on every http(s) origin exposing the whole images/ tree with no ' +
    'dynamic URL. The icons are conclusive and load without a CORS grant.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load images/icons/128.png via <img> — exposed to every origin and readable ' +
        'without a CORS grant, so it survives a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/icons/128.png'),
    },
    {
      id: 'war-icon-256',
      kind: 'web-accessible-resource',
      description: 'Load images/icons/256.png via <img> — a second icon corroborating the match.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/icons/256.png'),
    },
    {
      id: 'war-close-btn-svg',
      kind: 'web-accessible-resource',
      description:
        'Load images/icons/close-btn.svg via <img> — a vendor-named icon, a third path.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/icons/close-btn.svg'),
    },
  ],
};
